import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExcPdfviewerv3Component} from '../misc/exc-pdf-viewer-v3/exc-pdfviewerv3.component';
import {of} from 'rxjs';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';

@Component({
  selector: 'app-formular-version',
  templateUrl: './formular-version.component.html',
  styles: [
  ]
})
export class FormularVersionComponent extends ExcTranslation implements OnInit {
  @ViewChild(ExcPdfviewerv3Component) VCPdfViewer!: ExcPdfviewerv3Component;

  @Input()
  tabinstance: any;

  Data: any;

  isNew = false;
  loaded = false;
  init = true;
  closeTabinstance = false;

  ID: string | undefined = undefined;
  frmVData: {
    frmVID: string,
    frmV_frmTID: string,
    frmVUPT: string | undefined,
    frmV_Template_fileStreamID: string,
    frmV_fileStreamID: string,
    frmVName: string,
    frmVDescription: string,
    frmV_enmIdent_FormularVersionStatus: number,
    frmVFieldCollection: string
  } = {
    frmVID: '',
    frmV_frmTID: '',
    frmVUPT: undefined,
    frmV_Template_fileStreamID: '',
    frmV_fileStreamID: '',
    frmVName: '',
    frmVDescription: '',
    frmV_enmIdent_FormularVersionStatus: 2,
    frmVFieldCollection: ''
  };

  foreignData = {} as any;

  viewerurl = '';
  uploadedFile = undefined as any;

  receiptPDFViewer = {
    fileUploaded: (event: any): void => {
      this.uploadedFile = event.file;
    },
    pageClicked: (): void => {

    },
    onDocumentLoaded: async () => {
      if (!this.VCPdfViewer.isFileUploaded) {
        this.VCPdfViewer.viewer.forms.collection.clearAllFormFields();
        setTimeout(() => {
          this.VCPdfViewer.viewer.forms.collection.importFormFields(
            this.frmVData.frmVFieldCollection, false

          );
          this.VCPdfViewer.isDirty = false;
          this.VCPdfViewer.viewer.forms.importData.fillFieldsFromData(this.foreignData);
        }, 100);
      }

      this.modalSvc.showToast(
        this.getRessource('MessageViewerReady'),
        'md-toast bg-green',
        'fal fa-check'
      );

      return of(!this.init).toPromise();
    },
    onViewerReady: async () => {
      this.modalSvc.showToast(
        this.getRessource('MessageViewerReady'),
        'md-toast bg-green',
        'fal fa-check'
      );
      return of(!this.init).toPromise();
    }
  };

  constructor(
    private excRestService: ExcRestService,
    private modalSvc: ExgModalService,
    private enumSvc: EnumerationService,
    public excSecurity: ExcSecurityService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
    this.tabinstance.BeforeClose = () => {
      return this.checkBeforeClose();
    };
  }

  initialize(): void {
    if (this.Data.frmVID) {
      this.viewerurl = this.excRestService.computeUrl('FormularVersionR_Binary', {
        frmVID: this.Data.frmVID,
      });

      this.excRestService.get(
        this.excRestService.computeUrl('FormularVersionR', {
          frmVID: this.Data.frmVID
          , fkID: this.Data.fkID})
      ).subscribe((response: any) => {
        if (response?.success) {
          this.frmVData = response.data.FormularVersion;
          this.foreignData = response.data.ForeignData;
          this.loaded = true;
          this.isNew = false;
        }
      });
    } else {
      this.viewerurl = this.excRestService.computeUrl('FormularTemplateR_Binary', {
        frmTID: this.Data.frmTID,
      });

      this.excRestService.get(
        this.excRestService.computeUrl('FormularTemplateR', {
          frmTID: this.Data.frmTID
          , fkID: this.Data.fkID})
      ).subscribe((response: any) => {
        if (response?.success) {
          this.frmVData.frmVID = response.data.FormularTemplate.frmTID;
          this.frmVData.frmVName = response.data.FormularTemplate.frmTName;
          this.frmVData.frmV_frmTID = response.data.FormularTemplate.frmTID;
          this.frmVData.frmV_Template_fileStreamID = response.data.FormularTemplate.frmT_fileStreamID;
          this.frmVData.frmVFieldCollection = response.data.FormularTemplate.frmTFieldCollection;
          this.foreignData = response.data.ForeignData;
          this.loaded = true;
          this.isNew = true;
        }
      });
    }
  }

  save(cancelSave = false): void {
    if (cancelSave) {
      this.VCPdfViewer.isDirty = false;
      this.isNew = false;

      this.modalSvc.showToast(
        this.getResource('Canceled')
        , 'md-toast'
        , 'far fa-window-close'
      );

      this.closeTab();
      return;
    }

    console.log(this.isNew);

    if (!this.isNew) {
      if (!this.VCPdfViewer.isDirty && !this.VCPdfViewer.isFileUploaded) {
        return;
      }

      this.frmVData.frmVFieldCollection = this.VCPdfViewer.viewer.forms.collection.exportFormFields(false);

      if (!this.uploadedFile) {
        this.excRestService.put(this.excRestService.computeUrl('FormularVersionU', {
          frmVID: this.frmVData.frmVID
        }), this.frmVData).subscribe((response: any) => {
          if (response?.success) {
            this.frmVData = response.data.FormularVersion;
            this.loaded = true;
            this.VCPdfViewer.isDirty = false;

            this.modalSvc.showToast(
              'Formular gespeichert'
              , 'md-toast bg-green'
              , 'far fa-check');
          }
          this.closeTab();
        });
      } else if (this.uploadedFile) {
        const formData = new FormData();
        formData.append('file[]', this.uploadedFile, this.uploadedFile.name);
        formData.append('DataObject', JSON.stringify(this.frmVData));

        this.excRestService.put(
          this.excRestService.computeUrl('FormularVersionU_File', {
            frmVID: this.frmVData.frmVID,
          }), formData
        ).subscribe((response: any) => {
          if (response?.success) {
            this.uploadedFile = undefined;
            this.frmVData = response.data.FormularVersion;
            this.loaded = true;
            this.VCPdfViewer.isDirty = false;

            this.modalSvc.showToast(
              'Formular gespeichert'
              , 'md-toast bg-green'
              , 'far fa-check');
          }
          this.closeTab();
        });
      }
    } else {
      this.modalSvc.show('ModalFormularVersionComponent', Object.assign({}, this.frmVData, {frmVName: ''}))
        .subscribe((rtVal: any) => {
          if (rtVal) {
            this.VCPdfViewer.getFile()
              .then((formData) => {
                Object.assign(
                  rtVal, {
                    FKID: this.Data.fkID,
                    frmVFieldCollection: this.VCPdfViewer.viewer.forms.collection.exportFormFields(false)
                  }
                );

                console.log(rtVal);

                formData.set(
                  'DataObject',
                  JSON.stringify(rtVal)
                );
                return formData;
              })
              .then((fData) => {
                this.excRestService.post(
                  this.excRestService.computeUrl('FormularVersionC', {
                    frmTID: this.Data.frmTID,
                  }), fData
                ).subscribe((response: any) => {
                  if (response?.success) {
                    this.frmVData = response.data.FormularVersion;
                    this.loaded = true;
                    this.isNew = false;
                    this.VCPdfViewer.isDirty = false;

                    this.modalSvc.showToast(
                      'Formular gespeichert'
                      , 'md-toast bg-green'
                      , 'far fa-check');
                  }

                  this.closeTab();
                });
              });
          }
        });
    }
  }

  openSignatureModal(): void {
    if (this.isNew) {
      return;
    }
    this.modalSvc.show('ModalCalculationSignatureComponent', {
      frmVID: this.frmVData.frmVID,
      title: 'Formular unterschreiben',
      labelVN: 'Versicherungsnehmer',
      labelEntgegen: 'Sachverständiger'
    }).subscribe((result: any) => {
      if (result && result.signatureVN && result.signatureEntgegen) {
        this.excRestService.post(
          this.excRestService.computeUrl('FormularVersionC_SignedPDF',
            { frmVID: this.frmVData.frmVID }),
          {
            signatureVN: result.signatureVN,
            signatureEntgegen: result.signatureEntgegen,
            FKID: this.Data.fkID
          },
          { export: true }
        ).subscribe(() => {
          this.modalSvc.showToast(
            'PDF unterschrieben und gespeichert',
            'md-toast bg-green',
            'fal fa-check'
          );
          this.closeTab();
        });
      }
    });
  }

  openModalFormularVersionComponent(config?: any): void {
    if (this.isNew) {
      return;
    }
    Object.assign(config, {isNew: this.isNew});

    this.modalSvc.show('ModalFormularVersionComponent', config)
      .subscribe((rtVal: any) => {
        if (rtVal) {
          if (rtVal?.del) {
            if (this.excSecurity.isFeatured('FORMVDELETE')) {
              this.excRestService
                .delete(
                  this.excRestService.computeUrl('FormularVersionD', {
                    frmVID: rtVal.frmVID,
                  }), {
                    frmVUPT: rtVal.frmVUPT
                  }
                )
                .subscribe((ret: any) => {
                  if (ret.success) {
                    this.modalSvc
                      .showToast('Formular gelöscht'
                        , 'md-toast bg-green'
                        , 'far fa-check');
                  }
                  this.closeTab();
                });
            }
          } else {
            if (rtVal && rtVal.frmVID) {
              const dataObject = {
                frmVName: rtVal.frmVName,
                frmVDescription: rtVal.frmVDescription,
                frmV_enmIdent_FormularVersionStatus: rtVal.frmV_enmIdent_FormularVersionStatus,
                frmVUPT: rtVal.frmVUPT,
              };

              this.excRestService
                .put(this.excRestService.computeUrl('FormularVersionU', {
                  frmVID: this.frmVData.frmVID
                }), dataObject)
                .subscribe((ret: any) => {
                  if (ret.success) {
                    Object.assign(this.frmVData, {
                      frmVName: ret.data.FormularVersion.frmVName,
                      frmVDescription: ret.data.FormularVersion.frmVDescription,
                      frmV_enmIdent_FormularVersionStatus: ret.data.FormularVersion.frmV_enmIdent_FormularVersionStatus,
                      frmVUPT: ret.data.FormularVersion.frmVUPT,
                    });

                    this.modalSvc
                      .showToast('Formular gespeichert',
                        'md-toast bg-green',
                        'far fa-check');
                  }
                });
            }
          }
        }
      });
  }


  checkBeforeClose(): boolean {
    if (!this.VCPdfViewer?.isDirty && !this.isNew) {
      return true;
    }
    this.modalSvc
      .showSimple(
        this.getGlobal('Attention') + '!',
        this.getResource('UnsavedChanges'),
        true,
        true,
        this.getGlobal('Save'),
        this.getGlobal('Reject')
      )
      .subscribe(async (ret: boolean) => {
        this.closeTabinstance = true;
        this.save(!ret);
      });
    return false;
  }

  closeTab(): void {
    if (this.closeTabinstance) {
      this.tabinstance.Close();
    }
  }
}
